import { render, staticRenderFns } from "./prohibited_words_list.vue?vue&type=template&id=35e204d7"
import script from "./prohibited_words_list.vue?vue&type=script&lang=js"
export * from "./prohibited_words_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports